
































import { defineComponent, reactive } from "@vue/composition-api";

import { Document } from "@/tools/msa/models";

interface Props {
  document: Document;
}

export default defineComponent({
  name: "ItemForm",
  props: {
    document: { type: Object, required: true }
  },
  setup(props, context) {
    const form = reactive({
      name: "",
      date: props.document.date
    });

    const commit = () => {
      context.emit("add", { ...form });
      form.name = "";
      form.date = props.document.date;
    };

    return { form, commit };
  }
});
